import {Routes} from 'constants/routes';

import Button from 'components/Button/Button';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {useNavigate} from 'react-router-dom';
import {setModalAC} from 'store/modal/modalSlice';
import {deleteEditorACS} from 'store/singlePageEditor/requestAC';

import './DeactivatePageEditor.scss';

export default function DeactivatePageEditor() {
  const dispatch = useSetGlobalState();
  const navigate = useNavigate();

  const singleEditor = useGlobalState((state) => state.singlePageEditor.singleEditor);

  const handleClose = () => dispatch(setModalAC(null));

  const handleDeactivatePageEditor = () => {
    if (!singleEditor) return;

    dispatch(deleteEditorACS(singleEditor.id));
    navigate(Routes.EDITORS);
    handleClose();
  };

  if (!singleEditor) return null;

  return (
    <div className="deactivate-page-editor">
      <h1 className="deactivate-page-editor__title">Deactivate user?</h1>
      <p className="deactivate-page-editor__description">
        Are you sure you want to deactivate{' '}
        <span className="deactivate-page-editor__name">{singleEditor.attributes.nickname || '/'}’s</span> profile? All
        pubs managed by this editor will be automatically removed from their list.
      </p>
      <div className="deactivate-page-editor__actions">
        <Button onClick={handleClose} className="deactivate-page-editor__cancel" variant="tertiary-outlined">
          Cancel
        </Button>
        <Button onClick={handleDeactivatePageEditor} className="deactivate-page-editor__remove" variant="tertiary">
          Yes, Deactivate
        </Button>
      </div>
    </div>
  );
}
